import { request } from "common/HOC/WithRequest";

export const authAPI = {
  logout: (): Promise<unknown> => {
    return request<unknown>("/logout", "POST", undefined, { baseURL: "/" });
  },
};
